angular.module('shared').controller('ConfirmModalCtrl', ["$scope", "$modalInstance", function($scope, $modalInstance) {
  $scope.ok = function() {
    return $modalInstance.close();
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
